import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "add-timer"
};
const _hoisted_2 = {
  class: "executed-note"
};
const _hoisted_3 = {
  class: "mct-blue"
};
const _hoisted_4 = {
  class: "btn-group"
};
import { ref, toRefs, reactive, computed, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useSetTimerStore } from '@/store/setTimer';
export default /*@__PURE__*/_defineComponent({
  __name: 'AddTimer',
  props: {
    zoneInfo: {}
  },
  emits: ["addTimer"],
  setup(__props, {
    emit: __emit
  }) {
    const useSetTimer = useSetTimerStore();
    const {
      addTimerDialogVisible
    } = storeToRefs(useSetTimer);
    const props = __props;
    const {
      zoneInfo
    } = toRefs(props);
    const testingLocations = computed(() => zoneInfo.value.children ? zoneInfo.value?.children.map(item => {
      return item.location;
    }) : []);
    const locationOptions = computed(() => zoneInfo.value.availableOrgs.filter(item => {
      return !testingLocations.value.includes(item.orgName);
    }));
    const ruleFormRef = ref();
    const ruleForm = reactive({
      start: Math.floor(Math.random() * 60),
      interval: 30,
      testLocation: ''
    });
    const rules = reactive({
      start: [{
        required: true,
        message: 'Please select',
        trigger: 'change'
      }],
      interval: [{
        required: true,
        message: 'Please select',
        trigger: 'change'
      }],
      testLocation: [{
        required: true,
        message: 'Please select',
        trigger: 'change'
      }]
    });
    const descriptionText = computed(() => {
      const remainder = ruleForm.start % ruleForm.interval;
      const res = [remainder];
      let hourText = `${remainder}th`;
      for (const index of [1, 2, 3, 4, 5]) {
        const newNumber = res[0] + ruleForm.interval * index;
        if (newNumber < 60) {
          hourText += `, ${newNumber}th`;
        }
      }
      return hourText;
    });
    const emits = __emit;
    const getOrg = () => {
      const org = zoneInfo.value.availableOrgs.find(org => org.orgId === ruleForm.testLocation);
      return {
        orgName: org.orgName,
        orgId: org.orgId,
        vGroupId: org.vGroupId
      };
    };
    const handleAdd = () => {
      const org = getOrg();
      emits('addTimer', [ruleForm.start, ruleForm.interval, org]);
      addTimerDialogVisible.value = false;
    };
    onUnmounted(() => {
      ruleForm.interval = 30;
      ruleForm.testLocation = '';
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: ruleForm,
        rules: rules,
        "label-width": "200px",
        "status-icon": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "Test Location",
          prop: "testLocation"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: ruleForm.testLocation,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ruleForm.testLocation = $event)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationOptions.value, (location, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: location.orgName,
                value: location.orgId
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Interval",
          prop: "interval"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: ruleForm.interval,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ruleForm.interval = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "every 1 min",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "every 2 min",
              value: 2
            }), _createVNode(_component_el_option, {
              label: "every 3 min",
              value: 3
            }), _createVNode(_component_el_option, {
              label: "every 4 min",
              value: 4
            }), _createVNode(_component_el_option, {
              label: "every 5 min",
              value: 5
            }), _createVNode(_component_el_option, {
              label: "every 6 min",
              value: 6
            }), _createVNode(_component_el_option, {
              label: "every 10 min",
              value: 10
            }), _createVNode(_component_el_option, {
              label: "every 12 min",
              value: 12
            }), _createVNode(_component_el_option, {
              label: "every 15 min",
              value: 15
            }), _createVNode(_component_el_option, {
              label: "every 20 min",
              value: 20
            }), _createVNode(_component_el_option, {
              label: "every 30 min",
              value: 30
            }), _createVNode(_component_el_option, {
              label: "every 60 min",
              value: 60
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Start Time",
          prop: "start"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: ruleForm.start,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ruleForm.start = $event)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...Array(60).keys()], min => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: min,
                label: min + ' min',
                value: min
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _cache[4] || (_cache[4] = _createElementVNode("span", {
            class: "description"
          }, " Randomly assign a number between 0 and 59. ", -1))]),
          _: 1
        }), _createElementVNode("span", _hoisted_2, [_cache[5] || (_cache[5] = _createTextVNode(" Note: The tests will be executed at the  ")), _createElementVNode("span", _hoisted_3, _toDisplayString(descriptionText.value), 1), _cache[6] || (_cache[6] = _createTextVNode("  minute of each hour, and so on. "))])]),
        _: 1
      }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
        plain: "",
        onClick: _cache[3] || (_cache[3] = $event => addTimerDialogVisible.value = false)
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("Cancel")])),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleAdd
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("Submit")])),
        _: 1
      })])]);
    };
  }
});